module.exports = __webpack_public_path__ + "assets/img/information-video-cover.632e652d.jpg";